<template>
  <div class="expansion-panel">
    <div class="tw-flex">
      <h1 class="tw-text-16 tw-font-normal tw-w-full">
        {{ header }}
        <Icon class="tw-ml-auto tw-cursor-pointer tw-float-right" art="light" :width="16" :name="iconName" color="black" @click="toggleExpander" />
      </h1>
    </div>
    <hr v-if="divider" class="tw-text-gray-light">
    <div v-if="isExpanded" class="content tw-pt-4 tw-text-black" v-html="content"></div>
  </div>
</template>

<script>
import Icon from './Icon'
import { computed, ref } from '@vue/composition-api'

export default {
  name: 'ExpansionPanel',
  components: {
    Icon
  },
  props: {
    header: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    divider: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const isExpanded = ref(false)
    const iconName = computed(() => {
      return isExpanded.value ? 'angle-up' : 'angle-down'
    })

    function toggleExpander() {
      isExpanded.value = !isExpanded.value
      context.emit('toggleExpander', isExpanded.value)
    }

    return {
      isExpanded,
      iconName,
      toggleExpander
    }
  }
}
</script>

<style scoped lang="postcss">
</style>
